// Importing necessary libraries and components
import { BrowserRouter } from "react-router-dom"; // Enables routing without page reloads
import AppRoutes from "./routes/AppRoutes"; // Central route configuration
import { AuthProvider } from "./context/AuthContext"; // Provides authentication context
import { Toaster } from "react-hot-toast"; // Handles in-app toast notifications
import { LoaderProvider } from "./context/loadercontext";

const basename = process.env.REACT_APP_BASENAME || "/";

function App() {
  return (
    <div className="App">
      <LoaderProvider>
      {/* BrowserRouter enables client-side navigation using React Router. It allows the app to switch between pages without reloading. */}
      <BrowserRouter basename={basename}>
         {/*AuthProvider wraps the entire application and provides authentication-related data (user info, login/logout functions) to all components via React Context. */}
        <AuthProvider>
          {/* AppRoutes defines all the routes (pages) for the application. Example: '/', '/login', '/dashboard', etc. */}
          <AppRoutes />
           {/* Toaster from react-hot-toast displays temporary notification messages. It's used to show success, error, or info alerts with custom styling. */}
          <Toaster
            position="top-center" // Toasts appear centered at the top
            toastOptions={{
              duration: 4000, // Toast duration in milliseconds
              style: {
                background: '#363636', // Default background color
                color: '#fff', // Default text color
              },
              success: {
                style: {
                  background: '#22C55E', // Green background for success messages
                  color: '#fff',
                },
              },
              error: {
                style: {
                  background: '#EF4444', // Red background for error messages
                  color: '#fff',
                },
              },
            }}
          />
        </AuthProvider>
      </BrowserRouter>
      </LoaderProvider>
    </div>
  );
}

export default App;

